/** Layout owns its state and behavior; dependencies are passed in by main. */

export function register(app) {
  const { layout, navigation, hero } = app;

  layout.getScrollTop = function getScrollTop() {
    return window.scrollY;
  };

  layout.getViewportHeight = function getViewportHeight() {
    return window.innerHeight;
  };

  layout.usesSidebarNav = function usesSidebarNav() {
    const sidebarWidth = Number.parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--sidebar-width'),
    );
    return sidebarWidth > 0 && window.matchMedia && window.matchMedia('(min-width: 981px)').matches;
  };

  layout.getHeaderHeight = function getHeaderHeight() {
    const header = document.querySelector('header');
    const h = layout.usesSidebarNav() ? 0 : header ? header.getBoundingClientRect().height : 95;
    document.documentElement.style.setProperty('--header-height', h + 'px');
    return h;
  };

  layout.updatePageEndSpacer = function updatePageEndSpacer() {
    const spacer = document.getElementById('page-end-spacer');
    if (!spacer) return;
    spacer.style.height = '0px';
  };

  // Existing callers use this layout hook after route, media and viewport changes.
  // CSS clips the paper grid to each page as its content grows.
  layout.queueDotGridZoneUpdate = function queueDotGridZoneUpdate() {
    layout.updatePageEndSpacer();
  };

  layout.setActiveNavLink = function setActiveNavLink(page) {
    document.querySelectorAll('.desktop-nav a, .mobile-menu a').forEach((link) => {
      link.classList.remove('active-link');
      const route =
        link.dataset.nav || (link.dataset.page === 'quick-message' ? 'contact' : link.dataset.page);
      if (route === page) {
        link.classList.add('active-link');
        link.setAttribute('aria-current', 'page');
      } else link.removeAttribute('aria-current');
    });
  };

  layout.setLayoutMode = function setLayoutMode(mode) {
    const isHome = mode === 'home';
    document.body.classList.toggle('home-layout', isHome);
    document.body.classList.toggle('subpage-basic', !isHome);
    document.body.classList.remove('route-pending');
  };
}

/** Initializers are called explicitly, in dependency order, from main. */
export function prepareLayoutState(app) {
  app.layout.updatePageEndSpacer();
}

export function bindViewportEvents(app) {
  const { layout, navigation, hero } = app;
  window.addEventListener(
    'resize',
    () => {
      layout.getHeaderHeight();
      if (typeof hero.syncLoaderRollState === 'function') {
        hero.syncLoaderRollState();
      }
      layout.queueDotGridZoneUpdate();
      navigation.syncResponsiveMenuState();
    },
    { passive: true },
  );
  window.addEventListener('load', () => {
    layout.queueDotGridZoneUpdate();
    navigation.syncResponsiveMenuState();
  });
}
